import { useContext } from 'react';
import { AuthCtx } from './_barrel.js';

        const useAuth = () => useContext(AuthCtx);

export { useAuth };
